// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".HeaderLogo-module__container--1LBHj{width:11.278rem}.HeaderLogo-module__image--19UMN{display:block;height:auto;width:100%}\n", ""]);
// Exports
exports.locals = {
	"container": "HeaderLogo-module__container--1LBHj",
	"image": "HeaderLogo-module__image--19UMN"
};
module.exports = exports;
